import { csrfToken } from 'rails-ujs';

let movieId = null; // 動画IDを保持
let logged = false; // 閲覧履歴送信を保持
let preview = (location.href.match(/key/)) ? true : false; // previewキーの有無

$(document).ready(function() {
  initialize();
});

function initialize() {
  movieId = $('iframe[id^=videog_player]').data('movie_id');

  $(window).on('message', function(ev) {
    var org_data = ev.originalEvent.data;
    if (typeof(org_data) != "string" || org_data.indexOf("videog_player_event") < 0) {
      return; // ビデオグプレーヤーイベント以外は処理しない
    }

    // 通知データの "signature=videog_player_event&name=timeupdate&value=再生秒数" という文字列を分解して配列化
    var ev_strings = org_data.split("&");

    // オブジェクトに変換する
    var ev_data = {};
    for (var i = 0; i < ev_strings.length; i++) {
      var parts = ev_strings[i].split("=", 2);
      var label = parts[0];
      var data = decodeURIComponent(parts[1]);
      ev_data[label] = data;
    }

    // 一度送信済み or プレビュー表示の場合は送信しない
    if (logged || preview) {
      return;
    }

    // 変換したオブジェクトを基に実際の処理を行う
    if (ev_data.name == "play") {
      $.ajax({
        type: 'POST',
        url: '/api/log_movies',
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          'movie_id': movieId
        },
        success: function () {
          logged = true;
        },
        async: false,
        timeout: 10000,
      });
    }
  });
}
